export default __webpack_public_path__ + "city-map-800-372b395b07481360695d889368cce803.webp";